<template>
  <el-dialog :visible.sync="attendeeVisible" class="dialog" :before-close="close" width="600px">
    <v-row class="mb-5">
      <v-col>
        <span class="attendee-title">Attendees</span>
      </v-col>
    </v-row>
    <div
      class="mt-5 mb-5"
      style="overflow-y: auto; overflow-x: hidden; width: 100%; height: 210px; justify-content: center"
    >
      <v-row v-for="(attendee, index) in attendeeList" :key="index" align="center" justify="center">
        <v-col align="center" cols="auto">
          <v-avatar
            :color="attendee.userDisplayName || attendee.userFullName | iconBackground"
            class="logo"
            round
            size="30"
          >
            <span class="white--text text-sm-h6 cent" v-if="!attendee.userPicture">
              {{ attendee.userDisplayName || attendee.userFullName | iconFilter }}
            </span>
            <v-img :src="attendee.userPicture" v-else />
          </v-avatar>

          <font-awesome-icon
            v-if="index === 0"
            style="
              color: #ffc542;
              font-size: 15px;
              position: absolute;
              transform: translate(-30px, -10px);
              margin-left: 6px;
            "
            icon="crown"
          />
        </v-col>
        <v-col style="color: white">
          <b>{{ attendee.userDisplayName || attendee.userFullName }}</b>
        </v-col>
        <v-col cols="auto" v-if="!isMtOrganizer(attendee.userId, mtInfo.mtOrganizerUid)">
          <v-avatar color="#f56c6c" class="attendee-delete" round size="22">
            <font-awesome-icon
              icon="minus-circle"
              style="font-size: 20px; background-color: #f56c6c; color: #21343b; cursor: pointer"
              @click="deleteAttendee(index)"
            ></font-awesome-icon>
          </v-avatar>
        </v-col>
      </v-row>
    </div>
    <v-row align="center">
      <v-col>
        <v-autocomplete
          v-model="selectedList"
          :items="items"
          :placeholder="'Find User'"
          :item-text="'userDisplayName' || 'userFullName'"
          item-value="userId"
          filled
          dense
          dark
          outlined
          hide-details
          multiple
        >
          <template v-slot:selection="data">
            <v-chip
              style="margin-top: 5px; margin-bottom: 5px"
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="removeChip(data.item)"
            >
              <v-avatar
                :color="data.item.userDisplayName || data.item.userFullName | iconBackground"
                class="logo"
                round
                size="10"
                left
              >
                <span class="white--text text-sm-h8 cent" v-if="!data.item.userPicture">
                  {{ data.item.userDisplayName || data.item.userFullName | iconFilter }}
                </span>
                <v-img :src="data.item.userPicture" v-else />
              </v-avatar>

              <!-- <v-avatar left>
                <v-img :src="data.item.userPicture"></v-img>
              </v-avatar> -->
              {{ data.item.userDisplayName || data.item.userDisplayName }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <template>
              <v-avatar
                :color="data.item.userDisplayName || data.item.userFullName | iconBackground"
                round
                size="30"
                left
              >
                <span class="white--text text-sm-h6 cent" v-if="!data.item.userPicture">
                  {{ data.item.userDisplayName || data.item.userFullName | iconFilter }}
                </span>
                <v-img :src="data.item.userPicture" v-else />
              </v-avatar>
              <v-list-item-content style="padding-left: 20px">
                <!-- <v-list-item-title v-html="data.item.userDisplayName || data.item.userDisplayName"></v-list-item-title> -->
                <v-list-item-title v-html="data.item.userDisplayName || data.item.userDisplayName"></v-list-item-title>
                <v-list-item-subtitle v-html="data.item.memberType"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="auto">
        <font-awesome-icon icon="user-plus" style="font-size: 20px; color: #3f88f2; cursor: pointer" />
      </v-col>
    </v-row>
  </el-dialog>
</template>

<script>
import { getWsMember } from '@/services/api'
export default {
  name: 'AttendeeDialog',
  created() {
    this.makeAttendeeList(this.mtInfo.mtAttendeeList)
    this.getWsMember()
  },
  props: {
    mtInfo: {},
    attendeeVisible: Boolean,
  },
  data() {
    return {
      attendeeDialogVisible: false,
      selectedList: [],
      wsMemberList: [],
      attendeeList: [],
    }
  },
  methods: {
    close() {
      this.$emit('close', { type: 'Attendee', list: this.attendeeList })
    },
    deleteAttendee(member) {
      this.attendeeList.splice(member, 1)
    },
    async getWsMember() {
      try {
        let result = await getWsMember(this, this.$store.getters.selectedWsInfo.wsId)
        this.wsMemberList = result
      } catch (err) {
        console.log(err)
      }
    },
    makeAttendeeList(list) {
      this.attendeeList = []
      if (list && list.length > 0) {
        for (var item of list) {
          if (this.isMtOrganizer(item.userId, this.mtInfo.mtOrganizerUid)) {
            this.attendeeList.push(item)
          }
        }
        for (let tempItem of list) {
          if (!this.isMtOrganizer(tempItem.userId, this.mtInfo.mtOrganizerUid)) this.attendeeList.push(tempItem)
        }
      }
    },
    isMtOrganizer(val1, val2) {
      let userId = val1 || this.$store.getters.userInfo.userId
      let organizerId = val2 || this.mtInfo.mtOrganizerUid
      return userId === organizerId
    },
    removeChip(item) {
      const index = this.selectedList.indexOf(item.userId)
      if (index >= 0) this.selectedList.splice(index, 1)
    },
  },
  computed: {
    items() {
      return this.wsMemberList.filter((member) =>
        this.attendeeList.every((attendee) => !attendee.userId.includes(member.userId))
      )
    },
  },
}
</script>

<style scoped>
.attendee-title {
  color: white;
  font-weight: bold;
  font-size: 20px;
}

.dialog >>> .el-dialog__body {
  background: #21343b !important;
}

.dialog >>> .el-dialog__header {
  background: #21343b !important;
}
</style>
